/**
 * FERP Portal - Notification List Page (DRR-074: Tabulator DRY Template)
 *
 * MONITOR Phase: Messages sent to actors via email, SMS, push, and in-app channels.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function NotificationListPage() {
  return <TabulatorPrimitiveManager primitiveType="notification" />;
}

export default NotificationListPage;
